import React, { useEffect, useState } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import { toast } from "react-toastify";
// import Processing from "../../components/processing/processing";
import { useLocation } from "react-router-dom";
import { API } from "../../api/api";
import constants from '../../utils/contants';
import moment from "moment/moment";
import PhoneInput from "react-phone-input-2";

const DriverTab = () => {

    const [isEditable, setIsEditable] = useState(false);
    const [buttonValue, setButtonValue] = useState("Edit");
    const { state } = useLocation();
    const { driver } = state;

    useEffect(() => {
        getUserData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const getUserData = () => {
        // setLoading(true);
        formik.setFieldValue("firstname", driver?.firstname);
        formik.setFieldValue("lastname", driver?.lastname);
        formik.setFieldValue("vehicle", driver?.car_info?.car_type?._id);
        formik.setFieldValue("email", driver?.email);
        formik.setFieldValue("phone", driver?.phone_no);
        formik.setFieldValue("country_code", driver?.country_code);
        formik.setFieldValue("gender", driver?.gender);
        formik.setFieldValue("device_type", driver?.device_type);
        formik.setFieldValue("createdAt", driver?.createdAt);
        formik.setFieldValue("status", driver?.is_send_request);
        formik.setFieldValue("verified", driver?.is_verified_driver);
        // setLoading(false);
    };

    const validationSchema = Yup.object().shape({
        firstname: Yup.string().required("Please Enter Username"),
        lastname: Yup.string().required("Please Enter Username"),
        verified: Yup.string().required("Please Enter Username"),
        email: Yup.string().required("Please Enter email"),
        phone: Yup.number().required().positive().integer(),
        vehicle: Yup.string().required("Please Enter Vehicle"),
        gender: Yup.string().required("Please Select Gender"),
    });

    const formik = useFormik({
        initialValues: {
            firstname: "",
            lastname: "",
            email: "",
            vehicle: "",
            phone: "",
            country_code: "",
            gender: "",
            device_type: "",
            createdAt: "",
            verified: "",
        },
        validationSchema: validationSchema,
        onSubmit: async (values) => {
            console.log("values: ", values);
            const body = {
                // id: driver?._id,
                firstname: values?.firstname,
                lastname: values?.lastname,
                email: values?.email,
                car_info: {
                    car_type: values?.vehicle
                },
                phone_no: values?.phone,
                country_code: values?.country_code,
                gender: values?.gender,
                device_type: values?.device_type,
                createdAt: values?.createdAt,
                is_verified_driver: values?.verified
            };
            API(`update-driver/${driver?._id}`, "put", body, localStorage.getItem(constants.TOKEN))
                .then((res) => {
                    toast.success("Driver Details updated successfully ✅", {
                        position: toast.POSITION.TOP_RIGHT,
                        className: "bg-success text-white",
                    });
                    // navigate("/manage-driver");
                    // window.location.reload();
                })
                .catch((error) => {
                    toast.error("Error while updating Driver Details", {
                        position: toast.POSITION.TOP_RIGHT,
                    });
                    console.log("error: ", error);
                });
        },
    });

    const enableEditing = () => {
        setIsEditable(true);
        setButtonValue("Update");
    };



    return (
        <>
            <hr className="mt-4" />
            <div className="advice_form text-black select_visible">
            <div className="d-flex flex-column mt-3">
                    <label className="category_label">Verified</label>
                    <select
                        type="text"
                        name="verified"
                        disabled={isEditable ? false : true}
                        className="form form-control bg-transparent text-black"
                        // {...formik.getFieldProps("username")}
                        value={formik.values.verified}
                        onChange={(e) => {
                            formik.setFieldValue("verified", e.target.value?.trimStart())
                        }}
                    >
                        <option value="true">Yes</option>
                        <option value="false">No</option>
                    </select>
                    {formik.touched.verified && formik.errors.verified && (
                        <div className="text-danger">{formik.errors.verified}</div>
                    )}
                </div>
                <div className="d-flex flex-column mt-3">
                    <label className="category_label">First Name</label>
                    <input
                        type="text"
                        name="firstname"
                        disabled={isEditable ? false : true}
                        className="form form-control bg-transparent text-black"
                        // {...formik.getFieldProps("username")}
                        value={formik.values.firstname}
                        onChange={(e) => {
                            formik.setFieldValue("firstname", e.target.value?.trimStart())
                        }}
                    />
                    {formik.touched.firstname && formik.errors.firstname && (
                        <div className="text-danger">{formik.errors.firstname}</div>
                    )}
                </div>
                <div className="d-flex flex-column mt-3">
                    <label className="category_label">Last Name</label>
                    <input
                        type="text"
                        name="lastname"
                        disabled={isEditable ? false : true}
                        className="form form-control bg-transparent text-black"
                        // {...formik.getFieldProps("username")}
                        value={formik.values.lastname}
                        onChange={(e) => {
                            formik.setFieldValue("lastname", e.target.value?.trimStart())
                        }}
                    />
                    {formik.touched.lastname && formik.errors.lastname && (
                        <div className="text-danger">{formik.errors.lastname}</div>
                    )}
                </div>
                <div className="d-flex flex-column mt-3">
                    <label className="category_label">Email</label>
                    <input
                        type="text"
                        name="email"
                        disabled={isEditable ? false : true}
                        className="form form-control bg-transparent text-black type_password"
                        // {...formik.getFieldProps("email")}
                        value={formik.values.email}
                        onChange={(e) => {
                            formik.setFieldValue("email", e.target.value?.trimStart())
                        }}
                    />
                    {formik.touched.email && formik.errors.email && (
                        <div className="text-danger">{formik.errors.email}</div>
                    )}
                </div>
                <div className="d-flex flex-column mt-3">
                    <label className="category_label">Country Code</label>
                    <PhoneInput
                        country={"eg"}
                        enableSearch={true}
                        disabled={isEditable ? false : true}
                        value={formik.values.country_code}
                        onChange={(value) => {
                            formik.setFieldValue("country_code", value)
                        }}
                    />
                    {formik.touched.country_code && formik.errors.country_code && (
                        <div className="text-danger">{formik.errors.country_code}</div>
                    )}
                </div>
                <div className="d-flex flex-column mt-3">
                    <label className="category_label">Phone No.</label>
                    <input
                        type="text"
                        name="phone"
                        disabled={isEditable ? false : true}
                        className="form form-control bg-transparent text-black"
                        // {...formik.getFieldProps("username")}
                        value={formik.values.phone}
                        onChange={(e) => {
                            formik.setFieldValue("phone", e.target.value?.trimStart())
                        }}
                    />
                    {formik.touched.phone_no && formik.errors.phone_no && (
                        <div className="text-danger">{formik.errors.phone_no}</div>
                    )}
                </div>
                <div className="d-flex flex-column mt-3">
                    <label className="category_label">Gender</label>
                    <select
                        type="text"
                        name="gender"
                        disabled={isEditable ? false : true}
                        className="form form-control bg-transparent text-black"
                        // {...formik.getFieldProps("username")}
                        value={formik.values.gender}
                        onChange={(e) => {
                            formik.setFieldValue("gender", e.target.value?.trimStart())
                        }}
                    >
                        <option value="male">Male</option>
                        <option value="female">Female</option>
                    </select>
                    {formik.touched.gender && formik.errors.gender && (
                        <div className="text-danger">{formik.errors.gender}</div>
                    )}
                </div>
                <div className="d-flex flex-column mt-3">
                    <label className="category_label">Device Type</label>
                    <input
                        type="text"
                        name="device_type"
                        disabled={isEditable ? false : true}
                        className="form form-control bg-transparent text-black"
                        // {...formik.getFieldProps("username")}
                        value={formik.values.device_type}
                        onChange={(e) => {
                            formik.setFieldValue("device_type", e.target.value?.trimStart())
                        }}
                    />
                    {formik.touched.device_type && formik.errors.device_type && (
                        <div className="text-danger">{formik.errors.device_type}</div>
                    )}
                </div>
                <div className="d-flex flex-column mt-3">
                    <label className="category_label">Register Date</label>
                    <input
                        type="text"
                        name="createdAt"
                        disabled
                        className="form form-control bg-transparent text-black"
                        // {...formik.getFieldProps("username")}
                        value={moment(formik.values.createdAt).format('LLL')}
                        onChange={(e) => {
                            formik.setFieldValue("createdAt", e.target.value?.trimStart())
                        }}
                    />
                    {formik.touched.createdAt && formik.errors.createdAt && (
                        <div className="text-danger">{formik.errors.createdAt}</div>
                    )}
                </div>

                <div className="d-flex mt-5 justify-content-end gap-4">
                    <button
                        type="button"
                        className="form_button btn advice__category"
                        onClick={() => {
                            window.history.back();
                        }}
                    >
                        Back
                    </button>
                    <button
                        type="button"
                        className="form_button btn advice__category submit_btn12"
                        disabled={
                            buttonValue === "Update" &&
                            formik.values.firstname === driver?.firstname &&
                            formik.values.lastname === driver?.lastname &&
                            formik.values.email === driver?.email &&
                            formik.values.phone === driver?.phone_no &&
                            formik.values.country_code === driver?.country_code &&
                            formik.values.createdAt === driver?.createdAt &&
                            formik.values.device_type === driver?.device_type &&
                            formik.values.gender === driver?.gender &&
                            formik.values.vehicle === driver?.car_info?.car_type?.name
                        }
                        onClick={
                            buttonValue === "Update" ? formik.handleSubmit : enableEditing
                        }
                    >
                        {buttonValue}
                    </button>
                </div>
            </div>
        </>
    )
}

export default DriverTab